import { Injectable } from '@angular/core';
import { QueryFilter } from '../../models/query-filter.model';
import { IMigrationDataType, IVersioningData } from '../../interfaces/migration.interface';
import { MigrationService } from './migration.service';

@Injectable()
export class GlobalMigrationService {
  constructor(private migrationService: MigrationService) {}

  private versioningData: IVersioningData[] = [
    {
      version: 1,
      upgrade: function (data) {
        return data.reduce((datasetFilters: any[], filterGroup: any) => {
          filterGroup.dimensions.map(dimension => {
            datasetFilters.push({
              dataset: filterGroup.dataset,
              expressions: [
                new QueryFilter({
                  type: 'any',
                  key: dimension,
                  values: filterGroup.selection[dimension]
                })
              ]
            })
          });
          return datasetFilters;
        }, []);
      }
    }
  ]

  public get currentVersion() {
    return this.versioningData[this.versioningData.length - 1].version;
  }

  public migrate(data: IMigrationDataType): any {
    return this.migrationService.migrate(data, this.versioningData);
  }

  public getQueryMigrationData(query): IMigrationDataType {
    let data;

    if (!query.version) {
      data = {
        version: 0,
        data: query
      };
    } else {
      data = {
        version: query.version,
        data: query.data
      };
    }

    return data;
  }

}
